import { useAuth0 } from '@auth0/auth0-react';
import { datadogLogs } from '@datadog/browser-logs';
import { BlankScreen } from '@strata/react-page-templates';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import { LOGIN_REDIRECT_KEY } from 'services/constants';
import { handleError } from 'services/ErrorManagement';
import { fmhAPI, getFmhToken } from 'services/Http';
import { initializePendo } from 'services/pendoUtils';

/**
 * Component to be rendered on callback from Auth0.
 * Handles authentication of the user and redirects to /home.
 */
export const AuthCallback = () => {
    const { isLoading, user, getAccessTokenSilently } = useAuth0();
    const navigate = useNavigate();
    useEffect(() => {
        void (async () => {
            if (!isLoading) {
                try {
                    const fmhTokenResult = await getFmhToken({
                        accessToken: await getAccessTokenSilently(),
                    });

                    const accessToken = fmhTokenResult.access_token;
                    fmhAPI.base = fmhAPI.base.auth(`Bearer ${accessToken}`);

                    datadogLogs.logger.info('User Authenticated', { user });
                    initializePendo(fmhTokenResult, user);
                } catch (err) {
                    handleError('Error authenticating.', err);
                } finally {
                    const redirectPath = sessionStorage.getItem(LOGIN_REDIRECT_KEY);
                    navigate(redirectPath ?? '/home');
                }
            }
        })();
    }, [isLoading, user, getAccessTokenSilently, navigate]);

    return <BlankScreen />;
};
